import { useContext, useEffect, useState } from 'react';

/** @format */
import { Link } from 'react-router-dom';

import User from '../../Assets/Images/user 1.png';
import { EventContext } from '../../Contexts/EventContext';
import { error } from '../../Shared/Components/Toast';
import useApi from '../../Shared/hooks/api/Index';
import { checkLogin } from '../../Shared/hooks/authenticate';
import { useRole } from '../../Shared/hooks/CustomHooks';
import { removeStoredAuthToken } from '../../Shared/utils/authToken';

const Header = ({ headerFixed, showMobileMenu }) => {
  const eventContext = useContext(EventContext);
  const { can, canBoard } = useRole();
  const [loading, setLoading] = useState(false);
  const [showProfileMenu, setShowProfileMenu] = useState(false);

  useEffect(() => {
    const getUser = async () => {
      setLoading(true);
      await useApi.get(
        '/auth/me',
        {},
        (res) => {
          eventContext.authUser = res.data.data;
          setLoading(false);
        },
        (err) => {
          setLoading(false);
          error('هنگام دریافت اطلاعات پروفایل خطایی رخ داده است');
        },
      );
    };
    if (checkLogin()) {
      getUser();
    }
  }, []);

  const openProfileMenu = () => {
    let backDark = document.getElementById('dark-back');
    let profileMenu = document.getElementById('header-menu-profile');

    backDark.classList.remove('d-none');
    backDark.classList.add('d-flex');
    profileMenu.classList.remove('d-none');
    profileMenu.classList.add('d-flex');
  };
  const closeProfileMenu = () => {
    let backDark = document.getElementById('dark-back');
    let profileMenu = document.getElementById('header-menu-profile');

    profileMenu.classList.add('d-none');
    profileMenu.classList.remove('d-flex');
    backDark.classList.add('d-none');
    backDark.classList.remove('d-flex');
  };

  return (
    <>
      <header className={`w-100 ${headerFixed ? 'sticky-top' : ''}`}>
        <section className='container-fluid '>
          <div className='row'>
            <div className='col-6 col-sm-6 col-md-4 col-lg-4 col-xl-4'>
              <Link
                to='/'
                className='w-30 d-none d-sm-none d-md-flex d-lg-flex d-xl-flex flex-row justify-content-start'
              >
                <img
                  src={eventContext?.setting?.logo?.logo ?? ''}
                  alt='logo'
                  className='mt-2'
                  style={{ width: '90px' }}
                />
              </Link>
              <Link
                to='/'
                className='d-flex d-sm-flex d-md-none h-100 d-lg-none d-xl-none flex-row justify-content-start'
              >
                <img
                  src={eventContext?.setting?.logo?.logo ?? ''}
                  alt='logo'
                  className='mt-2 w-100'
                  style={{ width: '90px' }}
                />
              </Link>
            </div>
            <div className='col-6 col-sm-6 col-md-4 col-lg-4 col-xl-4 justify-content-center align-items-center mt-3 text-center'>
              <span className='f-14 font-weight-bold text-center text-break mt-3'>
                {eventContext?.setting?.name ?? ''}
              </span>
            </div>
            {loading ? null : (
              <div className='d-none d-sm-none d-md-flex d-lg-flex d-xl-flex col-md-4 col-lg-4 col-xl-4 justify-content-end'>
                {checkLogin() ? (
                  <>
                    <div className='d-flex flex-row justify-content-end c-pointer'>
                      <div
                        className='d-flex flex-row justify-content-end align-items-center c-pointer mt-2'
                        onClick={openProfileMenu}
                      >
                        <img
                          style={{
                            width: '60px',
                            height: '60px',
                          }}
                          src={
                            eventContext?.user?.avatar == null ||
                            eventContext?.user?.avatar === undefined
                              ? User
                              : eventContext?.user?.avatar
                          }
                          alt='user'
                          className='img-thumbnail rounded-circle rounded-pill'
                        />
                        <i className='fad fa-angle-down f-24 text-purple mx-3 align-self-center'></i>
                      </div>

                      <div
                        onClick={closeProfileMenu}
                        className='d-none vw-100 vh-100'
                        id='dark-back'
                        style={{
                          position: 'fixed',
                          zIndex: '99',
                          top: '0',
                          right: '0',
                        }}
                      ></div>
                      <div
                        id='header-menu-profile'
                        className='d-none flex-column bg-purple border-dark-mode rounded-1 shadow p-2 position-absolute'
                        style={{
                          width: '246px',
                          top: '55px',
                          left: '15px',
                          zIndex: '9999999',
                          opacity: '1',
                        }}
                      >
                        <div className='d-flex flex-row border-bottom-dark-mode text-center justify-content-center pb-2 p-2'>
                          <i className='fad fa-address-card f-18 text-dark-mode'></i>
                          <span className='text-dark-mode f-12 mx-2'>
                            لیست منو ها
                          </span>
                        </div>
                        <ul className='d-flex flex-column nav m-0 p-0'>
                          <li className='d-flex border-bottom-dark-mode my-1'>
                            <span className='w-100 d-flex flex-row justify-content-center py-2'>
                              <span className='text-dark-mode f-12 mx-2'>
                                {eventContext?.authUser?.first_name}{' '}
                                {eventContext?.authUser?.last_name} -{' '}
                                {eventContext?.authUser?.nat_code ?? ''}
                              </span>
                            </span>
                          </li>
                          <li className='d-flex border-bottom-dark-mode my-1'>
                            <Link to='/' className='w-100 d-flex flex-row py-2'>
                              <i className='fad fa-user text-dark-mode f-18'></i>
                              <span className='text-dark-mode f-12 mx-2'>
                                صفحه اصلی
                              </span>
                            </Link>
                          </li>

                          <li className='d-flex my-1 border-bottom-dark-mode'>
                            <Link
                              to='/panel/user/event'
                              className='w-100 d-flex flex-row py-2'
                            >
                              <i className='fad fa-user-cog text-dark-mode f-18'></i>
                              <span className='text-dark-mode f-12 mx-2'>
                                پنل کاربری
                              </span>
                            </Link>
                          </li>

                          <li className='d-flex my-1'>
                            <Link
                              onClick={(e) => {
                                e.preventDefault();
                                removeStoredAuthToken();
                                window.location.href = '/';
                              }}
                              to='#'
                              className='w-100 d-flex flex-row py-2'
                            >
                              <i className='fad fa-door-open text-dark-mode f-18'></i>
                              <span className='text-dark-mode f-12 mx-2'>
                                خروج
                              </span>
                            </Link>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </>
                ) : (
                  <div className='d-flex flex-row justify-content-center align-items-center'>
                    <Link to='/register' className='d-flex flex-row'>
                      <span className='text-purple mx-2 f-13 mt-1 font-weight-bold'>
                        ثبت نام
                      </span>
                    </Link>
                    <Link to='/login' className='d-flex flex-row'>
                      <span className='text-purple mx-2 f-13 mt-1 font-weight-bold'>
                        ورود به سایت
                      </span>
                    </Link>
                  </div>
                )}
              </div>
            )}
          </div>
        </section>
        <div className='w-100 bg-purple p-2 mt-2 '>
          <section className='d-md-none container-fluid'>
            <div className='row d-flex flex-row align-items-center'>
              <div className='col-6'>
                <i
                  className='fas fa-bars f-24 text-white'
                  onClick={() => showMobileMenu(true)}
                ></i>
              </div>
              <div className='col-6 d-md-none'>
                {loading ? null : (
                  <div className='d-md-none d-flex justify-content-end w-100'>
                    {checkLogin() ? (
                      <>
                        {can('Super Admin') ||
                        can('Dyaco Admin') ||
                        canBoard() ? (
                          <div className='d-flex flex-row justify-content-end c-pointer'>
                            <div
                              className='d-flex flex-row justify-content-end c-pointer'
                              onClick={() => setShowProfileMenu(true)}
                            >
                              <img
                                style={{
                                  width: '35px',
                                  height: '35px',
                                }}
                                src={
                                  eventContext?.user?.avatar == null ||
                                  eventContext?.user?.avatar === undefined
                                    ? User
                                    : eventContext?.user?.avatar
                                }
                                alt='user'
                                className='img-thumbnail rounded-circle rounded-pill'
                              />
                              <i className='fad fa-angle-down f-20 text-purple mx-3 align-self-center'></i>
                            </div>
                            {showProfileMenu && (
                              <>
                                <div
                                  onClick={() => setShowProfileMenu(false)}
                                  className='d-flex vw-100 vh-100'
                                  style={{
                                    position: 'fixed',
                                    zIndex: '99',
                                    top: '0',
                                    right: '0',
                                  }}
                                ></div>
                                <div
                                  className='d-flex flex-column border-dark-mode rounded-1 shadow p-2 position-absolute'
                                  style={{
                                    width: '50vh',
                                    top: '42px',
                                    zIndex: '9999999',
                                    opacity: '1',
                                    backgroundColor: '#6667AB',
                                  }}
                                >
                                  <div className='d-flex flex-row border-bottom-dark-mode text-center justify-content-center pb-2 p-2'>
                                    <i className='fad fa-address-card f-18 text-dark-mode'></i>
                                    <span className='text-dark-mode f-12 mx-2'>
                                      لیست منو ها
                                    </span>
                                  </div>
                                  <ul className='d-flex flex-column nav m-0 p-0'>
                                    <li className='d-flex border-bottom-dark-mode my-1'>
                                      <Link
                                        to='/'
                                        className='w-100 d-flex flex-row py-2'
                                      >
                                        <i className='fad fa-user text-dark-mode f-18'></i>
                                        <span className='text-dark-mode f-12 mx-2'>
                                          صفحه اصلی
                                        </span>
                                      </Link>
                                    </li>

                                    <li className='d-flex my-1 border-bottom-dark-mode'>
                                      <Link
                                        to='/panel/event'
                                        className='w-100 d-flex flex-row py-2'
                                      >
                                        <i className='fad fa-user-cog text-dark-mode f-18'></i>
                                        <span className='text-dark-mode f-12 mx-2'>
                                          پنل کاربری
                                        </span>
                                      </Link>
                                    </li>

                                    <li className='d-flex my-1'>
                                      <Link
                                        onClick={(e) => {
                                          e.preventDefault();
                                          removeStoredAuthToken();
                                          window.location.href = '/';
                                        }}
                                        to='#'
                                        className='w-100 d-flex flex-row py-2'
                                      >
                                        <i className='fad fa-door-open text-dark-mode f-18'></i>
                                        <span className='text-dark-mode f-12 mx-2'>
                                          خروج
                                        </span>
                                      </Link>
                                    </li>
                                  </ul>
                                </div>
                              </>
                            )}
                          </div>
                        ) : null}
                      </>
                    ) : (
                      <div className='d-flex flex-column justify-content-center align-items-center'>
                        <Link to='/login' className='d-flex flex-row'>
                          <span className='text-white mx-2 f-13 mt-1 font-weight-bold'>
                            ورود به سایت
                          </span>
                        </Link>
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>
          </section>
          <section className='container-fluid d-none d-md-block'>
            <div className='row'>
              <div className='d-flex flex-row'>
                <ul className='d-flex flex-row nav'>
                  <li className=''>
                    <Link className='text-dark-mode f-14 mx-2' to='/'>
                      صفحه اصلی
                    </Link>
                  </li>
                  <li className=''>
                    <Link className='text-dark-mode f-14 mx-2' to='/'>
                      درباره فدراسیون
                    </Link>
                  </li>
                  <li className=''>
                    <Link
                      className='text-dark-mode f-14 mx-2'
                      to='/payment/tracking'
                    >
                      پرداخت از طریق کد پیگیری{' '}
                    </Link>
                  </li>
                  <li className=''>
                    <Link className='text-dark-mode f-14 mx-2' to='/id-card'>
                      دریافت آی دی کارت
                    </Link>
                  </li>
                  <li className=''>
                    <a
                      target='_blank'
                      className='text-dark-mode f-14 mx-2'
                      href='https://athlete.ifsm.ir/Login'
                    >
                      سامانه پزشکی ورزشی
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </section>
        </div>
      </header>
    </>
  );
};
export default Header;
